"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var SVGTextBase = function SVGTextBase(props) {
  return _react.default.createElement("text", Object.assign({
    x: "50",
    width: "100%"
  }, props));
};

var _default = (0, _styledComponents.default)(SVGTextBase).withConfig({
  displayName: "SVGTextStyle",
  componentId: "sc-3qu6jq-0"
})(["alignment-baseline:middle;dominant-baseline:middle;text-transform:uppercase;user-select:none;"]);

exports.default = _default;
module.exports = exports.default;